import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class PayrollRemoteService {
  constructor(private httpClient: HttpClient) {}

  isClientEnabledForUploadFiles(dataCustomer: any): Observable<object> {
    return this.httpClient.post(
      environment.serverUrlSalaryLoans + "payrollCheck/client/status",
      dataCustomer,
    );
  }

  sendFileToTap(dataDocument: any) {
    return this.httpClient.post(
      environment.serverTapUrl + "file-provider-service/load",
      dataDocument,
    );
  }

  setPayrollFile(file: any): Observable<object> {
    return this.httpClient.post(
      environment.serverUrlSalaryLoans + "payrollCheck",
      file,
    );
  }
}
